import Accordion from '@components/Accordion';
import Column from '@components/Column';
import Text from '@components/Text';
import TextField from '@components/TextField';
import colors from '@constants/colors';
import { css } from '@emotion/react';
import styled from '@emotion/styled';
import { useTranslation } from 'react-i18next';

import useNickname from './hooks/useNickname';

/**
 * 닉네임 관리
 * @constructor
 */
function AccountManagement() {
    const { t } = useTranslation('accountSetting');
    const {
        nickname, setNickname, handleUpdateNickname,
    } = useNickname();
    return (
        <Accordion title={t('accountManagement.title')}>
            <Contents spacing={24} >
                <Column spacing={8} fullWidth>
                    <Text color={colors.gray6}
                        fontWeight='bold'
                        size='s'>{t('accountManagement.nickname')}</Text>
                    <TextField value={nickname}
                        maxLength={16}
                        onChange={(e) => setNickname(e.target.value)}
                        trailing={
                            <Text onClick={handleUpdateNickname}
                                fontWeight='bold'
                                color={colors.primary}
                                css={buttonCss} >
                                {t('accountManagement.change')}
                            </Text>} />
                </Column>
            </Contents>
        </Accordion>
    );
}

const Contents = styled(Column)`
    padding: 12px 0 20px;
`;

const buttonCss = css`
    padding: 10px 12px;
    text-decoration: underline;
    text-underline-offset: 2px;
`;

export default AccountManagement;
